import { useEffect } from 'react';

import { useOidc } from '@preqin/preqin-core/cjs/OIDC/oidc.utils';
import Loader from '@preqin/ui-components/cjs/core/Loader';

import styles from './oidc.module.scss';

const SessionLost = () => {
  const { login, isAuthenticated } = useOidc();

  useEffect(() => {
    !isAuthenticated && login('/');
  }, [isAuthenticated]);

  return (
    <div className={styles.oidcComponentWrapper}>
      <Loader
        isLoading={false}
        showError={true}
        showErrorButton={true}
        hideErrorMessage={false}
        onError={() => console.log('User session has been lost.')}
        onErrorButtonClick={() => login(window.location.href)}
        errorButtonText={'Reload'}
      />
    </div>
  );
};

export default SessionLost;
